import * as React from 'react';

import type {ThreadType} from 'nutshell-graphql-types';
import type {InboxChannelEventFragment_payload_Thread_startedFromUrl as Url} from 'nutshell-graphql-types';

import {colors} from '../../../colors/colors';
import {Link} from '../../../link/link';
import {Body} from '../../../typography/body';

import {getFormattedTimestampForChannelEvent} from '../../helpers';

import {getThreadBannerAction, getThreadBannerIcon} from './helpers';

import styles from './thread-banner.module.css';

type Props = {
    bannerType: 'started' | 'closed' | 'reopened';
    actorName: string | null | undefined;
    changeTime: any;
    threadType?: ThreadType;
    startedFromUrl?: Url;
};

export function ThreadBanner(props: Props) {
    const action = getThreadBannerAction(props.bannerType);
    const Icon = getThreadBannerIcon(props.bannerType);
    const showStartedFrom =
        props.bannerType === 'started' &&
        (props.threadType === 'CHAT' || props.threadType === 'MESSENGER') &&
        props.startedFromUrl;

    return (
        <div className='flex justify-center full-width'>
            <Body size='small' color='light' truncate={{type: 'block'}} textAlign='center'>
                <span className='inline-block full-width'>
                    {Icon && (
                        <span className={styles['banner-icon']}>
                            <Icon
                                size={14}
                                color={colors.grey}
                                className='mr-4'
                                alignCenter={true}
                                wrapWithDiv={false}
                            />
                        </span>
                    )}
                    {action} by {props.actorName || 'Someone'}
                    {showStartedFrom && props.startedFromUrl && (
                        <span className={styles['started-from-container']}>
                            &nbsp;from&nbsp;
                            <Link
                                variant='primary'
                                size='small'
                                href={props.startedFromUrl.fullyQualifiedUrl}
                                newTab={true}
                            >
                                {props.startedFromUrl.pageTitle || props.startedFromUrl.path || ''}
                            </Link>
                        </span>
                    )}
                    ,&nbsp;
                    {getFormattedTimestampForChannelEvent(props.changeTime)}
                </span>
            </Body>
        </div>
    );
}
